import React from "react";
import { Row, Col } from "react-bootstrap";
import "./MedicalTourism5.css";

const strengths = [
  {
    title: "ROBOTIC SURGERY",
    desc: "Sub-millimeter precision for complex procedures with faster recovery.",
    image: "/assets/robotic.png",
    icon: "/assets/key1.svg",
  },
  {
    title: "PROTON THERAPY",
    desc: "Targeted cancer treatment that spares healthy surrounding tissue.",
    image: "/assets/proton.png",
    icon: "/assets/key2.svg",
  },
  {
    title: "CAR T-CELL THERAPY",
    desc: "Advanced cellular therapy for select blood cancers and relapses.",
    image: "/assets/cell.png",
    icon: "/assets/key3.svg",
  },
  {
    title: "MINIMALLY INVASIVE SURGERY (MIS)",
    desc: "Smaller incisions, less pain, and a quicker path back to normal life.",
    image: "/assets/overlay.png",
    icon: "/assets/key4.svg",
  },
];

const MedicalTourism5 = () => {
  return (
    <section className="medicalStrengths standard-padding">
      <h1 className="heading text-center medicalStrengths-heading">
        Our Key Strengths
      </h1>

      <Row className="g-4">
        {strengths.map((item, index) => (
          <Col lg={6} key={index}>
            <div
              className="strengthCard"
              style={{
                backgroundImage: `url(${item.image})`,
              }}
            >
              <div className="strengthOverlay">
                <div className="strengthIcon">
                  <img src={item.icon} alt={item.title} />
                </div>

                <h4 className="strengthTitle">{item.title}</h4>

                <p className="strengthDesc">{item.desc}</p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default MedicalTourism5;
